/**
 * Ключ useTransition для получения кастомизации
 */
export const MAP_CUSTOMIZATION_KEY = 'MAP_CUSTOMIZATION_KEY'
